/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Switch, Segmented, Stepper, Tabs, Badge, StatusBadge, Modal, EmptyState, Pagination, FilterPanel, makeFilter, dateInFilter, toast, SectionTitle, PdfViewer, ReceiptUploadPaymentDialog, VOUCHERS, CUSTOMERS, SUPPLIERS, fmt, fmt0, fmtDec */
// `embedded` monterer innboksen i en modal over AI Regnskapsforeren. Innmaten
// er den samme siden — paginering, flervalg, dra-for-a-sla-sammen, filter og
// opplasting hoerer med, og en egen kopi ville hatt bare halvparten av dem.
// Det eneste som faller bort er sidetittelen (modalen har sin egen) og
// visningsbytte til papirkurv/dokumentasjon, som ikke er innboksarbeid.
const RECEIPT_PERIOD_MONTHS=['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'];
function InnboksPage({route,setRoute,year,embedded=false,hideBankLinkedReceipts=false,periodMonth=null,periodOnly=false,entryIds=null}){
  const backend=window.PlummeBackend;
  const consumeGlobalSearchTarget=()=>{const target=window.__plummeInboxSearchTarget||null;window.__plummeInboxSearchTarget=null;return target;};
  const [initialGlobalSearchTarget]=useState(consumeGlobalSearchTarget);
  const inputRef=useRef(null);
  const docInputRef=useRef(null);
  const [tick,setTick]=useState(0);
  const [view,setView]=useState(()=>route==='dokumentasjon'?'docs':'inbox');
  const [viewOpen,setViewOpen]=useState(false);
  const [uploadOpen,setUploadOpen]=useState(false);
  const [q,setQ]=useState(initialGlobalSearchTarget?.query||'');
  const [filter,setFilter]=useState(makeFilter());
  const [selected,setSelected]=useState([]);
  // Raden forrige klikk traff. Shift-klikk maler strekket derfra og hit.
  const anchorRef=useRef(null);
  const [expanded,setExpanded]=useState(initialGlobalSearchTarget?.id||null);
  const [busy,setBusy]=useState('');
  const [progress,setProgress]=useState(null);
  const [pendingUploadFiles,setPendingUploadFiles]=useState(null);
  // `periodOnly` er maanedskontrollens forvalg, ikke en sperre. Aa se bare
  // maaneden er riktig naar du kontrollerer den — men et bilag med feil dato,
  // eller et som aldri fikk lest datoen, ligger da utenfor og er usynlig
  // nettopp der brukeren leter etter det. Derfor kan maanedsvalget slaas av, og
  // lista sier alltid hvor mange som staar utenfor.
  const [periodFilter,setPeriodFilter]=useState(initialGlobalSearchTarget?false:periodOnly);
  useEffect(()=>{
    const openGlobalSearchTarget=()=>{
      const target=consumeGlobalSearchTarget();
      if(!target)return;
      setView('inbox');setQ(target.query||'');setExpanded(target.id||null);setPeriodFilter(false);setFilter(makeFilter());setSelected([]);
    };
    window.addEventListener('plumme-global-search-open',openGlobalSearchTarget);
    return()=>window.removeEventListener('plumme-global-search-open',openGlobalSearchTarget);
  },[]);
  const [drag,setDrag]=useState(false);
  const [dragId,setDragId]=useState(null);
  const [overId,setOverId]=useState(null);
  const [mergeId,setMergeId]=useState(null);
  const [paymentByEntry,setPaymentByEntry]=useState({});
  // Bekreftelsen for bulk-bokforing og gjennomgangen ett bilag om gangen. Begge
  // holder sin egen kopi av utvalget: lista endrer seg mens de star apne.
  const [planIds,setPlanIds]=useState(null);
  const [paySourceIds,setPaySourceIds]=useState(null);
  const [walkIds,setWalkIds]=useState(null),[assetEntry,setAssetEntry]=useState(null),[bareLines,setBareLines]=useState([]);
  useEffect(()=>{
    if(route==='dokumentasjon') setView('docs');
    if(route==='innboks') setView((current)=>current==='docs'?'inbox':current);
  },[route]);
  const [mailbox,setMailbox]=useState(null);
  const model=backend?.getReceiptInboxModel?.()||{active:[],trash:[],ready:[],entries:[]};
  const docsModel=backend?.getDocumentationInboxModel?.()||{active:[],trash:[],entries:[]};
  const isDocs=view==='docs';
  // Bilaget hoerer til maaneden det gjelder. Fikk OCR-en aldri lest datoen, hoerer
  // det ikke til noen maaned — og skal derfor vaere blant dem som faller utenfor,
  // ikke blant dem som er inne.
  const inSelectedPeriod=(entry)=>{
    const documentDate=entry.date||entry.receiptAnalysis?.receiptDate;
    return Boolean(documentDate)&&Boolean(window.apPeriodIn?.(documentDate,year,periodMonth));
  };
  const entries=(isDocs?docsModel.active:(view==='trash'?model.trash:model.active)).filter((entry)=>{
    // Bare koblede bilag det ikke er noe mer aa si om skjules. Et koblet bilag
    // som trenger kontroll maa vaere synlig der agenten teller det — se
    // `bankLinkedResolved` i backend-receipt-inbox.jsx.
    if((entryIds&&!entryIds.includes(String(entry.id)))||(!isDocs&&view!=='trash'&&hideBankLinkedReceipts&&entry?.bankLinkedResolved)) return false;
    const hay=isDocs
      ? [docInboxName(entry),entry.subject,entry.doctype,entry.received,entry.createdAt].filter(Boolean).join(' ').toLowerCase()
      : [receiptUiName(entry),entry.subject,entry.receiptAnalysis?.supplierName,entry.receiptAnalysis?.invoiceNumber,entry.receiptAnalysis?.suggestedCostAccountCode].filter(Boolean).join(' ').toLowerCase();
    if(q && !hay.includes(q.toLowerCase())) return false;
    if(!isDocs&&view!=='trash'&&periodFilter&&!inSelectedPeriod(entry)) return false;
    const analysisDate=isDocs?(entry.received||entry.createdAt):(entry.receiptAnalysis?.receiptDate||entry.received||entry.createdAt);
    if(!receiptDateInFilter(analysisDate,filter)) return false;
    if(isDocs||view==='trash') return true;
    const checks=filter.checks||{};
    const statusChecks=[checks.klar&&'ready-to-book',checks.mangler&&'needs-review'].filter(Boolean);
    // «Venter på analyse» leses ikke av `review.status` alene: et bilag som har
    // hengt seg på «Analyseres» faller gjennom til en tom kontrolliste og blir
    // stående som klart. Derfor er dette valget et eget predikat ved siden av
    // status-treffet, og ikke enda en verdi i `statusChecks`.
    const awaitsAnalysis=!!checks.venter;
    if(statusChecks.length||awaitsAnalysis){
      const hit=statusChecks.includes(entry.review?.status)||(awaitsAnalysis&&receiptAwaitsAnalysis(entry));
      if(!hit) return false;
    }
    // Bankkobling er en egenskap ved bilaget, ikke enda en status. Derfor snevrer
    // valget inn det statusvalgene slipper gjennom: «Til kontroll» sammen med
    // «Koblet til banklinje» betyr begge deler, ikke enten-eller.
    if(checks.bank&&!receiptLinkedToBankLine(entry)) return false;
    return true;
  });
  // Begge tallene tegnes, ogsaa naar det ene er null. «Alle (3)» ved siden av
  // «Februar (2)» er hele forklaringen paa hvorfor to lister av det samme
  // regnskapet viser forskjellig antall.
  const periodScope=(isDocs||view==='trash')?[]:(view==='trash'?model.trash:model.active)
    .filter((entry)=>!(hideBankLinkedReceipts&&entry?.bankLinkedResolved));
  const periodCounts={
    period:periodScope.filter(inSelectedPeriod).length,
    all:periodScope.length,
  };
  const periodLabel=periodMonth==null
    ? String(year||'')
    : `${new Intl.DateTimeFormat(window.PlummeI18n?.intlLocale?.()||'nb-NO',{month:'long',timeZone:'UTC'}).format(new Date(Date.UTC(2020,Number(periodMonth),1)))} ${year||''}`.trim();
  const entriesPage=usePaged(entries,10);
  useEffect(()=>entriesPage.setPage(1),[view,q,filter,tick]);
  const setEntriesPage=(page)=>{setExpanded(null);entriesPage.setPage(page);};
  const setEntriesPageSize=(size)=>{setExpanded(null);entriesPage.setPs(size);entriesPage.setPage(1);};
  const refresh=()=>setTick(x=>x+1);
  useEffect(()=>{
    const handler=()=>refresh();
    window.addEventListener('plumme-backend-state',handler);
    window.addEventListener('plumme-inbox-changed',handler);
    return ()=>{window.removeEventListener('plumme-backend-state',handler);window.removeEventListener('plumme-inbox-changed',handler);};
  },[]);
  useEffect(()=>{ setSelected([]); anchorRef.current=null; },[view,q,filter,tick]);
  useEffect(()=>{
    let alive=true;
    if(backend?.getInboundReceiptMailbox) backend.getInboundReceiptMailbox().then((result)=>{if(alive)setMailbox(result);}).catch(()=>{});
    return ()=>{alive=false;};
  },[backend?.activeBusinessId]);
  const hasFiles=(e)=>{try{return Array.from(e.dataTransfer?.types||[]).includes('Files');}catch(err){return false;}};
  const manualUploadIdsRef=useRef(new Set());
  // Knappen forteller bare om selve filopplastingen. Analysen vises ved siden av,
  // sa mobilknappen ikke ser ut som om kamera-/uploadhandlingen byttes til AI.
  const uploadButtonLabel=progress?.phase==='upload'
    ? t('bank.uploadingCount', 'Laster opp {{done}}/{{total}} …', { done: progress.done, total: progress.total })
    : (busy==='upload'||busy==='upload-docs'?t('bank.uploading', 'Laster opp …'):t('list.upload', 'Last opp'));
  const analyzeProgressLabel=progress?.phase==='analyze'
    ? t('bank.analyzingCount', { done: progress.done + 1, total: progress.total })
    : '';
  // Sytten bilag i samme slipp kom inn ett og ett, med en OCR-runde mellom hver:
  // det siste bilaget dukket opp minutter etter det forste, og det sa ut som om
  // opplastingen hang. Na lastes hele bunken opp forst — radene fyller innboksen
  // med en gang, merket «Venter pa analyse» — og analysen tar dem i tur etterpa.
  const upload=async(preparedFiles)=>{
    const list=Array.from(preparedFiles||[]).filter((item)=>item?.file); if(!list.length)return;
    const uploaded=[];
    const uploadedIds=[];
    setBusy('upload');
    setProgress({phase:'upload',done:0,total:list.length});
    try{
      for(const item of list){
        try{ const saved=await backend.uploadReceiptFileToInbox(item.file,{paymentSourceDecision:item.paymentSourceDecision}); uploaded.push(saved); if(saved?.id){ uploadedIds.push(saved.id); manualUploadIdsRef.current.add(saved.id); } }
        catch(err){ console.warn('Bilagsopplasting feilet for en fil.',err); }
        setProgress({phase:'upload',done:uploaded.length,total:list.length});
        refresh();
      }
      const uploadFailed=list.length-uploaded.length;
      if(uploaded.length) toast(uploadFailed?t('inbox.uploadPartialAnalyzing',{done:uploaded.length,total:list.length}):(list.length===1?t('inbox.uploadedSingle'):t('inbox.uploadedMultipleAnalyzing',{count:list.length})),uploadFailed?'warning':'success');
      else toast(list.length===1?t('inbox.uploadFailedSingle'):t('inbox.uploadFailedMultiple'),'error');
    }catch(err){ toast(err?.message||t('inbox.uploadFailedGeneric'),'error'); }
    finally{ if(inputRef.current) inputRef.current.value=''; }
    try{
      if(!uploaded.length) return;
      setBusy('analyze-batch');
      let failed=0;
      let stopped=null;
      for(let index=0;index<uploaded.length;index+=1){
        setProgress({phase:'analyze',done:index,total:uploaded.length});
        // En analyse som feiler stopper ikke resten. Bilaget blir staaende som
        // «Venter pa analyse» og kan analyseres pa nytt fra menyen paa raden.
        //
        // Unntaket er kvoten: er den brukt opp, feiler alle resterende bilag paa
        // samme maate. Aa kjore videre gir bare nitti like feilmeldinger og nitti
        // skrivinger til basen. Da stopper vi, og resten blir staaende i ko.
        try{ await backend.analyzeReceiptInboxEntry(uploaded[index].id,{markPending:false}); }
        catch(err){
          failed+=1;
          if(err?.quotaExhausted||err?.rateLimited||err?.providerUnavailable){ stopped=err; refresh(); break; }
        }
        refresh();
      }
      if(stopped) toast(stopped.message+' '+t('inbox.remainingAwaitingAnalysisSuffix',{count:uploaded.length-failed}),'error');
      else if(failed) toast(failed===uploaded.length
        ?(failed===1?t('inbox.uploadedButAnalysisFailedSingle'):t('inbox.uploadedButAnalysisFailedMultiple'))
        :t('inbox.partialAnalysisFailed',{failed,total:uploaded.length}),'warning');
    }finally{
      uploadedIds.forEach((id)=>manualUploadIdsRef.current.delete(id));
      setProgress(null);
      setBusy('');
    }
  };
  const requestReceiptUpload=(files)=>{
    const list=Array.from(files||[]).filter(Boolean);
    if(!list.length)return;
    if(inputRef.current) inputRef.current.value='';
    setPendingUploadFiles(list);
  };
  const uploadDocs=async(files)=>{
    const list=Array.from(files||[]); if(!list.length)return;
    setBusy('upload-docs');
    try{
      for(const file of list) await backend.uploadDocumentFileToInbox(file);
      toast(list.length===1?t('inbox.documentAddedSingle'):t('inbox.documentAddedMultiple'),'success');
      refresh();
    }catch(err){ toast(err?.message||t('inbox.documentUploadFailed'),'error'); }
    finally{ setBusy(''); if(docInputRef.current) docInputRef.current.value=''; }
  };
  const uploadForCurrentView=(files)=>isDocs?uploadDocs(files):requestReceiptUpload(files);
  useEffect(()=>{
    const filesFromClipboard=(event)=>{
      const direct=Array.from(event.clipboardData?.files||[]);
      if(direct.length) return direct;
      return Array.from(event.clipboardData?.items||[])
        .map((item)=>item.kind==='file'?item.getAsFile():null)
        .filter(Boolean);
    };
    const onPaste=(event)=>{
      const files=filesFromClipboard(event);
      if(!files.length) return;
      event.preventDefault();
      uploadForCurrentView(files);
    };
    const onDragOver=(event)=>{ if(hasFiles(event)) event.preventDefault(); };
    const onDragEnter=(event)=>{ if(!hasFiles(event)) return; event.preventDefault(); setDrag(true); };
    const onDrop=(event)=>{
      if(event.defaultPrevented||!hasFiles(event)) return;
      event.preventDefault();
      setDrag(false);
      uploadForCurrentView(event.dataTransfer.files);
    };
    window.addEventListener('paste',onPaste);
    window.addEventListener('dragover',onDragOver);
    window.addEventListener('dragenter',onDragEnter);
    window.addEventListener('drop',onDrop);
    return ()=>{
      window.removeEventListener('paste',onPaste);
      window.removeEventListener('dragover',onDragOver);
      window.removeEventListener('dragenter',onDragEnter);
      window.removeEventListener('drop',onDrop);
    };
  },[view,backend?.activeBusinessId]);
  // Bilag som kommer inn pa e-post lages av backend, og ingen har hittil startet
  // analysen av dem — den ble bare utlost av klienten rett etter en opplasting.
  // De ble derfor liggende ubehandlet til noen fant «Analyser» i radmenyen.
  // Her plukkes koen opp, ett bilag om gangen sa en full innboks ikke gir en storm
  // av parallelle kall, og med tak per visning.
  // Functions kan arbeide i opptil 120 sekunder. Etter en reload finnes ikke
  // klienten som skulle lagre svaret lenger; da blir raden staaende paa
  // «Analyseres». Vent til det opprinnelige kallet sikkert er ferdig foer raden
  // tas opp igjen. Resultatcachen gjoer den nye runden tokenfri naar serveren
  // rakk aa fullfoere.
  const autoAnalyzeRef=useRef({running:false,done:new Set()});
  useEffect(()=>{
    if(isDocs||view==='trash'||!backend?.analyzeReceiptInboxEntry) return;
    const state=autoAnalyzeRef.current;
    if(state.running) return;
    const now=Date.now();
    const queued=model.active
      // Et bilag som er koblet til en banklinje skal ikke analyseres her.
      // Slippes en fil paa en linje som alt er godkjent eller bokfort, hoppes
      // analysen over med vilje — linja sier fra for hva kjopet var. Uten dette
      // filteret ville denne koen tatt den likevel, neste gang innboksen sto
      // apen. `receiptCanManualAnalyze` sier det samme for radmenyen.
      .filter((entry)=>entry.status!=='linked-bank-line'&&entry.bookedAs!=='bank-line')
      .filter((entry)=>(entry.receiptAnalysis?.status==='queued'||receiptAnalysisInterrupted(entry,now))&&!manualUploadIdsRef.current.has(entry.id)&&!state.done.has(entry.id))
      .slice(0,10);
    if(!queued.length){
      const retryAt=model.active
        .filter((entry)=>['pending','extracting','processing'].includes(entry.receiptAnalysis?.status)&&!state.done.has(entry.id))
        .map((entry)=>receiptAnalysisStartedAt(entry)+RECEIPT_ANALYSIS_STALE_MS)
        .filter(Number.isFinite)
        .sort((left,right)=>left-right)[0];
      if(!retryAt) return;
      const timer=window.setTimeout(()=>refresh(),Math.max(50,retryAt-now));
      return ()=>window.clearTimeout(timer);
    }
    let cancelled=false;
    state.running=true;
    (async()=>{
      for(const entry of queued){
        if(cancelled) break;
        state.done.add(entry.id);
        // En feil skal ikke stoppe resten. Bilaget far status «Analyse feilet» av
        // backend-laget og kan proves igjen fra radmenyen.
        try{ await backend.analyzeReceiptInboxEntry(entry.id); }
        catch(err){ if(err?.quotaExhausted||err?.providerUnavailable) break; }
      }
      state.running=false;
      if(!cancelled) refresh();
    })();
    return ()=>{ cancelled=true; };
  },[isDocs,view,tick,backend?.activeBusinessId]);
  const analyze=async(entry)=>{
    setBusy('analyze-'+entry.id);
    try{ await backend.analyzeReceiptInboxEntry(entry.id,{forceReanalysis:true}); toast(t('inbox.analyzed'),'success'); refresh(); return true; }
    catch(err){ toast(err?.message||t('inbox.analyzeActionFailed'),'error'); return false; }
    finally{ setBusy(''); }
  };
  // Bokforingen svarer na med hva som faktisk skjedde per bilag. Toasten sier det
  // samme: «12 bokfort» nar 3 ble hoppet over er en halv sannhet.
  const reportBooking=(result)=>{
    const booked=result?.booked?.length||0;
    const skipped=result?.skipped?.length||0;
    const failed=result?.failed||[];
    if(failed.length){ toast(failed[0]?.reason||t('svc.bookFailed'),'error'); return; }
    if(!booked){ toast(result?.skipped?.[0]?.reason||t('inbox.bookedNoneReason'),'warning'); return; }
    if(skipped){ toast(t('inbox.bookedSummary',{booked,skipped}),'warning'); return; }
    toast(booked===1?t('inbox.bookedOne'):t('inbox.bookedCount',{count:booked}),'success');
  };
  // Ett bilag om gangen: bare fakturanummeret sperrer. Duplikatvarselet star
  // allerede pa raden, og brukeren har sett det.
  const bookReady=async(ids,paymentAccount)=>{
    if(!ids.length)return false;
    setBusy('book');
    try{
      const result=await backend.bookReadyReceiptInboxEntries(ids,{duplicates:'allow',...(paymentAccount?{paymentAccount}:{})});
      reportBooking(result);
      const bookedIds=new Set((result?.booked||[]).map((item)=>item.id));
      setSelected((list)=>list.filter((id)=>!bookedIds.has(id)));
      refresh();
      return bookedIds.size?{bookedIds:Array.from(bookedIds)}:null;
    }
    catch(err){ toast(err?.message||t('inbox.bookFailedFallback'),'error'); return false; }
    finally{ setBusy(''); }
  };
  const trashOne=async(id)=>{
    setBusy('walk-trash');
    try{ setBareLines((await backend.moveReceiptInboxEntriesToTrash([id]))?.undocumentedLines||[]); setSelected((list)=>list.filter((value)=>value!==id)); refresh(); return true; }
    catch(err){ toast(err?.message||t('inbox.moveToTrashFailed'),'error'); return false; }
    finally{ setBusy(''); }
  };
  const moveTrash=async(ids)=>{ if(!ids.length)return false; setBusy('trash'); try{ setBareLines((await backend.moveReceiptInboxEntriesToTrash(ids))?.undocumentedLines||[]); toast(ids.length===1?t('inbox.movedToTrash'):t('inbox.movedToTrashCount',{count:ids.length}),'info'); setSelected([]); refresh(); return true; }catch(err){toast(err?.message||t('inbox.moveToTrashFailed'),'error');return false;} finally{setBusy('');} };
  const restore=async(ids)=>{ if(!ids.length)return false; setBusy('restore'); try{ await backend.restoreReceiptInboxEntries(ids); toast(ids.length===1?t('inbox.restoredOne'):t('inbox.restoredCount',{count:ids.length}),'success'); setSelected([]); refresh(); return true; }catch(err){toast(err?.message||t('inbox.restoreFailed'),'error');return false;} finally{setBusy('');} };
  const deleteNow=async(ids)=>{ if(!ids.length||!window.confirm(ids.length===1?t('inbox.confirmDeletePermanentOne'):t('inbox.confirmDeletePermanentMany')))return; setBusy('delete'); try{ await backend.deleteReceiptInboxEntriesNow(ids); toast(t('inbox.deletedPermanently'),'info'); setSelected([]); refresh(); }catch(err){toast(err?.message||t('inbox.deleteFailed'),'error');} finally{setBusy('');} };
  const moveDocTrash=async(ids)=>{ if(!ids.length)return false; setBusy('trash-docs'); try{ await backend.moveDocumentationInboxEntriesToTrash(ids); toast(ids.length===1?t('inbox.docMovedToTrash'):t('inbox.docMovedToTrashCount',{count:ids.length}),'info'); setSelected([]); refresh(); return true; }catch(err){toast(err?.message||t('inbox.docMoveToTrashFailed'),'error');return false;} finally{setBusy('');} }; const restoreDocs=async(ids)=>{ if(!ids.length)return false; setBusy('restore-docs'); try{ await backend.restoreDocumentationInboxEntries(ids); toast(ids.length===1?t('inbox.docRestored'):t('inbox.docRestoredCount',{count:ids.length}),'success'); setSelected([]); refresh(); return true; }catch(err){toast(err?.message||t('inbox.docRestoreFailed'),'error');return false;} finally{setBusy('');} };
  const deleteDocsNow=async(ids)=>{ if(!ids.length||!window.confirm(ids.length===1?t('inbox.confirmDeleteDocOne'):t('inbox.confirmDeleteDocMany')))return; setBusy('delete-docs'); try{ await backend.deleteDocumentationInboxEntriesNow(ids); toast(t('inbox.docDeletedPermanently'),'info'); setSelected([]); refresh(); }catch(err){toast(err?.message||t('inbox.docDeleteFailed'),'error');} finally{setBusy('');} };
  const downloadSelected=async(ids)=>{
    const rows=entries.filter((entry)=>ids.includes(entry.id));
    if(!rows.length)return;
    setBusy('download');
    try{
      const label=isDocs?t('inbox.wordDocuments'):t('inbox.wordVouchers');
      const result=await backend.downloadInboxAttachmentsArchive(rows,{fileName:`${label}-${purchaseTodayIso()}.zip`});
      if(result?.failed?.length) toast(t('inbox.downloadPartial',{downloaded:result.downloaded,total:result.downloaded+result.failed.length}),'warning');
      else toast(result?.zipped?t('inbox.downloadedZip',{count:result.downloaded}):t('inbox.downloadedSingleFile'),'success');
    }catch(err){ toast(err?.message||t('inbox.downloadFilesFailed'),'error'); }
    finally{ setBusy(''); }
  };
  const moveToDocs=async(ids)=>{
    if(!ids.length)return;
    setBusy('move-docs');
    try{ const count=await backend.moveReceiptInboxEntriesToDocumentation(ids); toast((count||ids.length)===1?t('inbox.movedToDocs'):t('inbox.movedToDocsCount',{count:count||ids.length}),'success'); setSelected([]); refresh(); }
    catch(err){ toast(err?.message||t('inbox.moveToDocsFailed'),'error'); }
    finally{ setBusy(''); }
  };
  const mergeInto=async(sourceIds,targetId)=>{
    const ids=Array.from(new Set((sourceIds||[]).filter(id=>id&&id!==targetId)));
    if(!ids.length||!targetId) return;
    setBusy('merge');
    try{ await backend.mergeReceiptInboxEntries(ids,targetId); toast(t('inbox.mergedCount',{count:ids.length+1}),'success'); setSelected([]); refresh(); }
    catch(err){ toast(err?.message||t('inbox.mergeFailed'),'error'); }
    finally{ setBusy(''); }
  };
  const splitEntry=async(entry)=>{
    if(asAttachments(entry).length<2) return;
    setBusy('split-'+entry.id);
    try{ await backend.splitReceiptInboxEntry(entry.id); toast(t('inbox.splitAgainDone'),'success'); refresh(); }
    catch(err){ toast(err?.message||t('inbox.splitAgainFailed'),'error'); }
    finally{ setBusy(''); }
  };
  const routeEntry=(entry,route)=>{
    window.PlummePurchaseRoutedReceipt.route(entry,route);
    setRoute&&setRoute(route);
  };
  // Shift-klikk tar hele strekket fra forrige klikk, ctrl/cmd-klikk plukker
  // enkeltrader. Regelen ligger i PlummeListSelection, ankeret i anchorRef.
  const pickRow=(id,event)=>{
    const selection=window.PlummeListSelection;
    const extend=selection.isExtendClick(event);
    if(extend) selection.clearTextSelection();
    // Strekket holdes innenfor siden man ser. Over et sideskift ville shift-klikk
    // dratt med seg rader ingen har sett, og bulkhandlingene gjelder dem ogsaa.
    const next=selection.nextSelection({ids:entriesPage.slice.map((entry)=>entry.id),selected,anchorId:anchorRef.current,targetId:id,extend});
    anchorRef.current=next.anchorId;
    setSelected(next.selected);
  };
  const toggle=(id,event)=>pickRow(id,event);
  const selectAll=()=>{ anchorRef.current=null; setSelected(selected.length===entries.length?[]:entries.map(entry=>entry.id)); };
  // Modifikatorklikk pa selve raden, ikke bare pa avkryssingen: da slipper man a
  // treffe det lille feltet for hver rad man vil ha med.
  const rowPick=(id,event)=>{
    const selection=window.PlummeListSelection;
    if(!selection.isExtendClick(event)&&!selection.isPickClick(event)) return;
    if(event.target.closest&&event.target.closest('button,a,input,select,textarea,label')) return;
    event.preventDefault();
    pickRow(id,event);
  };
  const dragIdsFor=(id)=>selected.includes(id)&&selected.length>1?selected:[id];
  const email=mailbox?.address||backend?.appState?.settings?.inboundReceiptEmail||backend?.appState?.settings?.receiptInboxEmail||'';
  // Grunnlaget for de to hintene over lista.
  const missingPaymentSourceCount=isDocs?0:model.active.filter((entry)=>safeReviewReasons(entry).some((reason)=>/betalingskilde/i.test(reason))).length;
  const hasRegisteredCards=(backend?.appState?.settings?.bankAccounts||[]).some((account)=>(account.cards||[]).length>0);
  // Tallet paa SuperPlumma-knappen: bare de valgte som star som klare. Planen i
  // dialogen kan trekke fra dubletter i tillegg, saa dette er et tak - ikke et
  // loefte om hvor mange som faktisk blir bokfort.
  const selectedIdSet=new Set(selected);
  const selectedReadyCount=isDocs?0:model.active.filter((entry)=>selectedIdSet.has(entry.id)&&receiptInboxEntryCanBook(entry)).length;
  const openBankSettings=()=>{
    window.plummeNav?.('innstillinger');
    window.dispatchEvent?.(new CustomEvent('plumme-settings-tab',{detail:'bank'}));
  };
  const setEntryPayment=(entry,value)=>setPaymentByEntry(current=>({...current,[entry.id]:value}));
  const entryPayment=(entry)=>paymentByEntry[entry.id]||receiptDefaultPaymentAccount(entry); useInboxPageControlAdapter({page:isDocs?'documentation':'inbox',view,query:q,selected,busy,entries:()=>entries,setView,setQuery:setQ,setSelected,setExpanded,canBook:receiptInboxEntryCanBook,openAttachmentPicker:()=>isDocs?docInputRef.current?.click():inputRef.current?.click(),analyze,archive:isDocs?moveDocTrash:moveTrash,restore:isDocs?restoreDocs:restore,book:bookReady,routeEntry});
  // Opplasting og filter foelger med inn i modalen. De staar i sidetoppen paa
  // siden og alene i modalen, saa de bor vaere ett uttrykk begge steder.
  const headerActions=<div className="row gap-10 wrap">
    {!isDocs&&email&&<span className="row gap-4 inbox-mailto" style={{minWidth:0}}><span className="t-sm muted" style={{fontWeight:700,overflowWrap:'anywhere'}}>{t('inbox.sendTo')} <b style={{color:'var(--ink)'}}>{email}</b></span><IconButton name="copy" size="sm" variant="ghost" onClick={()=>{navigator.clipboard?.writeText(email);toast(t('inbox.addressCopied'),'success');}}/></span>}
    <input ref={inputRef} type="file" multiple accept="image/*,application/pdf" style={{display:'none'}} onChange={e=>requestReceiptUpload(e.target.files)}/>
    <input ref={docInputRef} type="file" multiple accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,text/plain" style={{display:'none'}} onChange={e=>uploadDocs(e.target.files)}/>
    <div className="popwrap" style={{display:'inline-block'}}>
      <Button size="sm" icon="upload" iconRight="chevDown" disabled={busy==='upload'||busy==='upload-docs'} onClick={()=>setUploadOpen(o=>!o)}>{uploadButtonLabel}</Button>
      {uploadOpen&&<React.Fragment><div className="pop-scrim" onClick={()=>setUploadOpen(false)}/>
        <div className="pop pop-menu right inbox-upload-menu">
          <button onClick={()=>{setUploadOpen(false);inputRef.current&&inputRef.current.click();}}><Icon name="mail" size={16}/>{t('inbox.toInbox')}</button>
          <button onClick={()=>{setUploadOpen(false);docInputRef.current&&docInputRef.current.click();}}><Icon name="doc" size={16}/>{t('inbox.toDocumentation')}</button>
        </div></React.Fragment>}
    </div>
    {analyzeProgressLabel&&<span className="t-sm muted" style={{fontWeight:800}}>{analyzeProgressLabel}</span>}
    <FilterPanel value={filter} onChange={setFilter} onReset={()=>{setFilter(makeFilter());setQ('');}} dates period year={year} groups={[{label:t('inbox.filterStatus'),options:[{key:'klar',label:t('inbox.filterReadyToPost')},{key:'mangler',label:t('inbox.filterNeedsReview')},{key:'venter',label:t('inbox.filterAwaitingAnalysis')}]},{label:t('inbox.filterBankConnection'),options:[{key:'bank',label:t('sharedText.bank.receiptLinked')}]}]}/>
  </div>;
  return <div>
    <Card pad={false} style={{padding:'22px 24px',position:'relative'}}
      onDragOver={e=>{if(hasFiles(e))e.preventDefault();}}
      onDragEnter={e=>{if(!hasFiles(e))return;e.preventDefault();setDrag(true);}}
      onDragLeave={e=>{if(!hasFiles(e))return;setDrag(false);}}
      onDrop={e=>{if(!hasFiles(e))return;e.preventDefault();e.stopPropagation();setDrag(false);uploadForCurrentView(e.dataTransfer.files);}}>
      {embedded?<div className="row between gap-10 wrap">
        {periodOnly&&periodMonth!=null?<Segmented soft value={periodFilter?'period':'all'} onChange={(value)=>setPeriodFilter(value==='period')}
          options={[{value:'period',label:`${periodLabel} (${periodCounts.period})`},{value:'all',label:`${t('bank.allMonths', 'Alle måneder')} (${periodCounts.all})`}]}/>:<span/>}
        <div className="row gap-10 wrap" style={{justifyContent:'flex-end'}}>{headerActions}</div>
      </div>
        :<PageHeader title={isDocs?t('route.documentation'):view==='trash'?t('inbox.trashTitle'):t('route.inbox')} subtitle={isDocs?t('inbox.docsSubtitle'):t('inbox.inboxSubtitle')} help titleHelp={t('inbox.titleHelp')} card={false}>
        {headerActions}
      </PageHeader>}
      {!embedded&&<div className="popwrap" style={{display:'inline-block',marginTop:14}}>
        <Button className="inbox-view-btn" size="sm" variant="secondary" icon={isDocs?'files':view==='trash'?'trash':'mail'} iconRight="chevDown" onClick={()=>setViewOpen(o=>!o)}>{isDocs?t('inbox.docsWithCount',{count:docsModel.active.length}):view==='trash'?t('inbox.trashWithCount',{count:model.trash.length}):t('inbox.inboxWithCount',{count:model.active.length})}</Button>
        {viewOpen&&<React.Fragment><div className="pop-scrim" onClick={()=>setViewOpen(false)}/>
          <div className="pop pop-menu inbox-view-menu" style={{minWidth:260}}>
            <button onClick={()=>{setView('inbox');setViewOpen(false);setSelected([]);}}><Icon name="mail" size={16}/><span>{t('inbox.inboxWithCount',{count:model.active.length})}</span>{view==='inbox'&&<Icon name="check" size={16} style={{marginLeft:'auto'}}/>}</button>
            <button onClick={()=>{setView('trash');setViewOpen(false);setSelected([]);}}><Icon name="trash" size={16}/>{t('inbox.trashWithCount',{count:model.trash.length})}{view==='trash'&&<Icon name="check" size={16} style={{marginLeft:'auto'}}/>}</button>
            <React.Fragment><div className="rowmenu-sep"/><button onClick={()=>{setView('docs');setViewOpen(false);setSelected([]);}}><Icon name="doc" size={16}/>{t('inbox.docsWithCount',{count:docsModel.active.length})}{isDocs&&<Icon name="check" size={16} style={{marginLeft:'auto'}}/>}</button></React.Fragment>
          </div></React.Fragment>}
      </div>}
      <div className="ph-sep"/>
      <div className="mt-16">
        <Input icon="search" placeholder={isDocs?t('inbox.searchDocsFull'):t('bank.searchVouchers')} value={q} onChange={e=>setQ(e.target.value)} style={{width:'100%'}}/>
      </div>
      {/* Kortregisteret er den billigste veien til riktig betalingskilde, men det
          er usynlig til noen leter etter det. Naar flere bilag mangler kilde og
          ingen kort er registrert, sier innboksen fra der problemet oppstaar. */}
      {!isDocs&&view==='inbox'&&missingPaymentSourceCount>=3&&!hasRegisteredCards&&<div className="inbox-tip">
        <Icon name="card" size={16}/>
        <div style={{minWidth:0,flex:1}}>
          <b>{t('inbox.cardNudgeTitle',{count:missingPaymentSourceCount})}</b>
          <div className="t-sm">{t('inbox.cardNudgeText')}</div>
        </div>
        <Button size="sm" variant="secondary" onClick={openBankSettings}>{t('inbox.cardNudgeAction')}</Button>
      </div>}
      {entries.length>0&&<div className="row between" style={{marginTop:18}}>
        <button className="row gap-8" onClick={selectAll} type="button" style={{background:'none',border:0,padding:0,cursor:'pointer',font:'inherit',color:'var(--ink)',textDecoration:'none'}}><span className={'inbox-check'+(selected.length===entries.length?' on':'')}>{selected.length===entries.length&&<Icon name="check" size={13}/>}</span><b className="t-sm">{t('inbox.selectAll')}</b></button>
        <span className="row gap-12">
          <span className="t-sm muted inbox-select-hint">{t('inbox.selectHint')}</span>
          <span className="t-sm muted" style={{fontWeight:800}}>{entries.length} {isDocs?t('inbox.wordDocuments'):t('inbox.wordVouchers')}</span>
        </span>
      </div>}
      {selected.length>0&&<div className="inbox-bulk" style={{marginTop:14}}>
        <span className="t-sm" style={{fontWeight:800}}>{t('r1p.selectedCount', { count: selected.length })}</span>
        <button className="link-reset" onClick={()=>setSelected([])} style={{marginRight:'auto'}}>{t('inbox.clearSelection')}</button>
        <IconButton name="download" size="sm" disabled={busy==='download'} title={busy==='download'?t('inbox.downloading'):t('inbox.downloadAll')} onClick={()=>downloadSelected(selected)}/>
        {view==='trash'
          ? <React.Fragment><Button size="sm" variant="secondary" icon="refresh" onClick={()=>restore(selected)}>{t('inbox.restoreAll')}</Button><Button size="sm" variant="danger-solid" icon="trash" onClick={()=>deleteNow(selected)}>{t('inbox.deletePermanently')}</Button></React.Fragment>
          : isDocs
            ? <Button size="sm" variant="secondary" icon="trash" onClick={()=>moveDocTrash(selected)}>{t('inbox.deleteAll')}</Button>
            : <React.Fragment><InboxMoveMenu options={[{icon:'files',label:t('route.documentation'),onClick:()=>moveToDocs(selected)},{icon:'trash',label:t('inbox.trashTitle'),onClick:()=>moveTrash(selected)}]}/><Button size="sm" variant="secondary" icon="bank" onClick={()=>setPaySourceIds(selected)}>{t('inbox.setPaymentSource')}</Button><Button size="sm" variant="secondary" iconRight="arrowRight" onClick={()=>setWalkIds(selected)}>{t('inbox.reviewSelected',{count:selected.length})}</Button><span title={selectedReadyCount?null:t('inbox.postNoneReady')}><Button size="sm" icon="sparkle" disabled={!selectedReadyCount} onClick={()=>setPlanIds(selected)}>{t('inbox.postWithAi',{count:selectedReadyCount})}</Button></span></React.Fragment>}
      </div>}
      <div className="mt-16">
        {entries.length===0
          ? <EmptyState acc="none" noVisual title={isDocs?t('inbox.emptyDocsTitle'):view==='trash'?t('inbox.emptyTrashTitle'):t('bank.noInboxVouchers')} text={isDocs?t('inbox.emptyDocsText'):t('bank.noInboxVouchersHelp')} action={isDocs?<Button icon="upload" onClick={()=>docInputRef.current&&docInputRef.current.click()}>{t('inbox.uploadDocument')}</Button>:view==='inbox'?<Button icon="upload" onClick={()=>inputRef.current&&inputRef.current.click()}>{t('buy.uploadDoc')}</Button>:null} compact/>
          : <div className="col gap-10">{entriesPage.slice.map(entry=>{
            const isOpen=expanded===entry.id; const selectedRow=selected.includes(entry.id);
            const attachments=asAttachments(entry); const isMerge=mergeId===entry.id&&dragId!=null&&dragId!==entry.id; const isOver=overId===entry.id&&dragId!=null&&dragId!==entry.id; const dimmed=dragId!=null&&dragIdsFor(dragId).includes(entry.id);
            return <div key={entry.id}
              draggable={view!=='trash'&&!isDocs}
              onDragStart={e=>{ if(view==='trash'||isDocs)return; setDragId(entry.id); e.dataTransfer.effectAllowed='move'; try{e.dataTransfer.setData('text/plain',String(entry.id));}catch(err){} }}
              onDragOver={e=>{ if(view==='trash'||isDocs||dragId==null||dragId===entry.id)return; e.preventDefault(); e.stopPropagation(); const rect=e.currentTarget.getBoundingClientRect(); const rel=(e.clientY-rect.top)/rect.height; if(rel>0.28&&rel<0.72){setMergeId(entry.id);setOverId(null);}else{setOverId(entry.id);setMergeId(null);} }}
              onDrop={e=>{ if(view==='trash'||isDocs||dragId==null||dragId===entry.id)return; e.preventDefault(); e.stopPropagation(); if(mergeId===entry.id)mergeInto(dragIdsFor(dragId),entry.id); setDragId(null); setOverId(null); setMergeId(null); }}
              onDragEnd={()=>{setDragId(null);setOverId(null);setMergeId(null);}}
              style={{position:'relative',border:'1px '+(isMerge?'dashed var(--plum-500)':'solid '+(isOver?'var(--plum-400)':'var(--border)')),borderRadius:'var(--r-md)',background:isMerge?'var(--plum-100)':isOver?'var(--plum-50)':'var(--card)',overflow:isOpen?'hidden':'visible',opacity:dimmed?.5:1,transition:'border-color .12s,background .12s'}}>
              {isMerge&&<div className="inbox-merge-cue"><Icon name="merge" size={16}/>{t('inbox.mergeToOne')}</div>}
              <div data-app-control="true" className="row gap-12 inbox-row" style={{padding:'13px 15px',alignItems:'center'}} onClick={(event)=>rowPick(entry.id,event)}>
                <button className={'inbox-check'+(selectedRow?' on':'')} onClick={(event)=>toggle(entry.id,event)} type="button" style={{flex:'none'}} title={t('inbox.selectHint')}>{selectedRow&&<Icon name="check" size={13} stroke={3}/>}</button>
                {view!=='trash'&&!isDocs&&<span className="inbox-grip" title={t('inbox.dragToMerge')}><Icon name="grip" size={16}/></span>}
                <span className="icon-chip" style={{background:'var(--panel)',flex:'none',position:'relative'}}><Icon name={isDocs?'files':attachments.length>1?'files':'receipt'} size={18}/>{attachments.length>1&&<span className="inbox-att-badge">{attachments.length}</span>}</span>
                <ReceiptInboxRowSummary entry={entry} isDocs={isDocs}/>
                <div className="row gap-8 inbox-row-acts" style={{flex:'none'}}>
                  <Button size="sm" variant="secondary" icon={isOpen?'chevUp':'eye'} onClick={()=>setExpanded(isOpen?null:entry.id)}>{isOpen?t('inboxStatus.hide'):t('inboxStatus.show')}</Button>
                  {view==='trash'
                    ? <React.Fragment><Button size="sm" variant="secondary" icon="refresh" onClick={()=>restore([entry.id])}>{t('inbox.restore')}</Button><IconButton name="trash" size="sm" variant="ghost" onClick={()=>deleteNow([entry.id])}/></React.Fragment>
                    : isDocs
                      ? <React.Fragment><ReceiptInboxRowMenu entry={entry}/><IconButton name="trash" size="sm" variant="ghost" onClick={()=>moveDocTrash([entry.id])}/></React.Fragment>
                    : <React.Fragment>
                        <Button size="sm" variant="secondary" disabled={!receiptInboxEntryCanBook(entry)||busy==='book'} onClick={()=>bookReady([entry.id],entryPayment(entry))}>{t('inbox.post')}</Button>
                        <ReceiptInboxRowMenu entry={entry} onRoute={(route)=>routeEntry(entry,route)} onAsset={()=>setAssetEntry(entry)} onSplit={()=>splitEntry(entry)} onAnalyze={()=>analyze(entry)}/>
                        <IconButton name="trash" size="sm" variant="ghost" title={t('inbox.moveToTrash')} onClick={()=>moveTrash([entry.id])}/>
                      </React.Fragment>}
                </div>
              </div>
              {isOpen&&<div style={{borderTop:'1px solid var(--border)',background:'var(--panel)',padding:14}}>
                <ReceiptInboxExpanded entry={entry} isDocs={isDocs} paymentAccount={entryPayment(entry)} onPaymentAccount={(value)=>setEntryPayment(entry,value)} onBook={(account)=>bookReady([entry.id],account||entryPayment(entry))} onSaved={refresh} busy={busy}/>
              </div>}
            </div>;
          })}</div>}
        {entriesPage.total>0&&<div className="mt-16"><Pagination {...entriesPage} onPage={setEntriesPage} pageSize={entriesPage.ps} onPageSize={setEntriesPageSize} pageSizes={[10,50,100]}/></div>}
      </div>
      {drag&&<div className="inbox-drop"><div className="inbox-drop-inner"><b>{isDocs?t('inboxStatus.dropDocuments'):t('inboxStatus.dropReceipts')}</b><span className="muted" style={{fontWeight:600}}>{isDocs?t('inboxStatus.dropDocumentsHint'):t('inboxStatus.dropReceiptsHint')}</span></div></div>}
    </Card>
    {pendingUploadFiles&&<ReceiptUploadPaymentDialog files={pendingUploadFiles}
      busy={busy==='upload'||busy==='analyze-batch'} onClose={()=>setPendingUploadFiles(null)}
      onConfirm={(prepared)=>{setPendingUploadFiles(null);void upload(prepared);}}/>}
    {paySourceIds&&<ReceiptPaymentSourceBulkDialog ids={paySourceIds} onClose={()=>setPaySourceIds(null)} onSaved={()=>{setPaySourceIds(null);setSelected([]);refresh();}}/>}
    {planIds&&<ReceiptBookingPlanDialog ids={planIds} onClose={()=>setPlanIds(null)} onChanged={(outcome)=>{
      const done=new Set((outcome?.booked||[]).map((item)=>item.id));
      setSelected((list)=>list.filter((id)=>!done.has(id)));
      refresh();
    }}/>}
    {walkIds&&<ReceiptInboxWalkthrough entries={entries} ids={walkIds} busy={busy}
      paymentFor={entryPayment} onPaymentFor={setEntryPayment}
      onBook={(id,account)=>bookReady([id],account)} onTrash={trashOne} onSaved={refresh}
      onBookReadyNow={()=>{setWalkIds(null);setPlanIds(walkIds);}}
      onClose={()=>setWalkIds(null)}/>}
    {assetEntry&&window.EiendelModal&&<window.EiendelModal open groups={window.readFixedAssetsModel?.(year)?.groups||[]} prefill={receiptFixedAssetPrefill(assetEntry)} onClose={()=>setAssetEntry(null)} onSaved={()=>{setAssetEntry(null);refresh();}}/>}
    {/* Bilaget er borte fra linja, men kravet om dokumentasjon er det ikke: var
        dette den eneste, spor vi om «bilag mangler» med en gang. Avbryter
        brukeren, staar mangelen igjen som flagg i Bank. */}
    {bareLines.length>0&&window.BankMissingReceiptModal&&<window.BankMissingReceiptModal line={bareLines[0]}
      onClose={()=>setBareLines((list)=>list.slice(1))}
      onConfirm={async(reason)=>{ await backend.setBankLineReceiptRequirement(bareLines[0].statementId,bareLines[0].id,true,reason); setBareLines((list)=>list.slice(1)); refresh(); toast(t('bank.voucherMarkedLostToast'),'success'); }}/>}
  </div>;
}

// Arbeidslista i AI Regnskapsforeren bygger pa de samme delene som innboksen:
// raden, redigeringen under den og bokforingsdialogen. Bare skallet rundt er
// forskjellig — der skal du godkjenne og bokfore, ikke rydde i papirkurven.
const PURCHASE_PAGES={PurchaseAccountPicker,PurchaseSupplierPicker,NyttKjopPage,AlleBilagPage,FriPosteringPage:FriPosteringPageV2,AnnetSalgPage,InnboksPage,DokumentasjonPage,KontoField,PayAccountSelect,KONTOPLAN:getKontoplan(),TRANSACTION_PAGES,
  ReceiptInboxRowSummary,ReceiptInboxExpanded,ReceiptInboxRowMenu,receiptDefaultPaymentAccount,receiptUiStatus};
Object.assign(window,PURCHASE_PAGES,{ReceiptInboxPreview,PurchaseForm,BackendReceiptPreview,uploadPurchaseReceiptFiles});
window.dispatchEvent?.(new CustomEvent('plumme-page-registered',{detail:{pages:Object.keys(PURCHASE_PAGES)}}));
